import React from "react";

interface PageHeaderProps {
  name?: React.ReactNode;
  children?: React.ReactNode;
  capitalize?: boolean;
}

// Not the top bar, the header of a page
const PageHeader = (props: PageHeaderProps) => {
  return (
    <div className="page-header">
      <div className="page-header__main">
        {props.children}
        <h2 className={`page-header__name ${props.capitalize ? "capitalize" : ""}`}>
          {!props.name ? null : <span>{props.name}</span>}
        </h2>
      </div>
    </div>
  );
};

export default PageHeader;
